import Flickity from "flickity";
require('flickity-fade');

export default function () {

  const clientsCarousels = document.querySelectorAll('.js-clients-carousel');

  if(clientsCarousels) {
    clientsCarousels.forEach(function (elem, index) {
      if (elem) {
        // Define carousel options
        let carouselOptions = {
          cellAlign: 'left',
          prevNextButtons: false,
          autoPlay: 4000,
          fade: true,
          pageDots: false
        };


        new Flickity(elem, carouselOptions);
      }
    });
  }
}
